export default __webpack_public_path__ + "static/media/down.ffe2935f.svg";